import React from "react";
import {
  EmployeeCacheContext,
  useEmployeeCacheState,
} from "../../hooks/useEmployeeCache";

interface EmployeeCacheProviderProps {
  children: React.ReactNode;
}

export const EmployeeCacheProvider: React.FC<EmployeeCacheProviderProps> = ({
  children,
}) => {
  const cacheState = useEmployeeCacheState();

  return (
    <EmployeeCacheContext.Provider value={cacheState}>
      {children}
    </EmployeeCacheContext.Provider>
  );
};
